import React from 'react';
import { isNotEmpty, DATA_NOT_AVAILABLE } from '../../containers/doc_view/utils';
import './DocTableAsRows.scss';
import {DocRow, DocRowProps} from '../doc_row';

interface DocTableAsRowsProps {
  title?: string;
  headers: string[];
  rows: string[][];
  empty: string;
  className?: string;
}

const mergeArrays = (headers: string[], rows: string[][]) =>
  rows.map(row =>
    headers.reduce(
      (acc: DocRowProps[], curr: string, index: number) => [
        ...acc,
        { title: curr, value: row[index] },
      ],
      []
    )
  );

export const DocTableAsRows: React.FC<DocTableAsRowsProps> = ({
  title,
  headers,
  rows,
  empty,
  className,
}) => {
  const hasRows = isNotEmpty(rows);

  const data = hasRows ? mergeArrays(headers, rows) : [];

  return (
    <div className="doc-table-as-row">
      <div className="doc-table-as-row__title">{title}</div>
      {isNotEmpty(data) ? (
        data.map((tableRow, index) => (
          <>
            <div className="doc-table-as-row__number">{`№${index + 1}`}</div>{' '}
            {tableRow.map((row, index) => (
              <DocRow {...row} key={`key-doc-table-as-row-${index + 1}`} />
            ))}
          </>
        ))
      ) : (
        <>
          <div className="doc-table-as-row__border-top"></div>
          <div className="doc-table-as-row__no-data">{empty || DATA_NOT_AVAILABLE}</div>
        </>
      )}
    </div>
  );
};
